import { Injectable } from '@angular/core';
import { CurrentEnvironment } from '@twaice-fe/environments/shared';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root',
})
export class SingleSignOnService {
  loginWithInternalMicrosoft365() {
    Auth.federatedSignIn({
      customProvider: CurrentEnvironment.getLoginConfig().ssoConfig.identityProvider,
    });
  }

  isSingleSignOnEnabled(): boolean {
    const federatedSignIn = CurrentEnvironment.getLoginConfig().ssoConfig;
    if (!federatedSignIn) return false;

    return federatedSignIn.allowedHost === window.location.host;
  }
}
